import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { LanguageProvider } from './lib/language-context'
import { AppProvider } from './lib/app-context'
import { Toaster } from '@/components/ui/toaster'
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LanguageProvider>
      <AppProvider>
        <App />
        <Toaster />
      </AppProvider>
    </LanguageProvider>
  </StrictMode>,
)
